import React from 'react';
import { resourceTranslationApi } from '@cp/shared/api/core/resource/translation';
import { TranslationMnemonic, TranslationMnemonicsForGroup } from '@common/model/resource/translationMnemonic';
import { TranslationGroup } from '@common/model/resource/translationGroup';

const TRANSLATION_FALLBACK = '';

export const useTranslations = <G extends TranslationGroup>(
  group: G,
): [(mnemonic: TranslationMnemonicsForGroup<G>) => string, { isLoading: boolean }] => {
  const { data, isLoading, isError } = resourceTranslationApi.useGetTranslationsQuery({ group });

  return [
    React.useCallback(
      (mnemonic) => {
        if (isLoading || isError || !data) {
          return TRANSLATION_FALLBACK;
        }

        const groupTranslations = data[group];

        return String(groupTranslations?.[mnemonic as TranslationMnemonic] || TRANSLATION_FALLBACK);
      },
      [data, group, isError, isLoading],
    ),
    { isLoading },
  ];
};
